import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { AppConfigService } from '@citi-gcg-173875/citi-utils';
import { HttpClient } from '@angular/common/http';
import { throwError, of, catchError, map } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';


@Injectable()
export class HoneyPotService {
  config: any;
  endpointMap: any;
  channel: any;
  endpoints: Map<string, string>;

    constructor(public _appConfigService: AppConfigService,
        private _http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: string) {
            this.setConfig();
        }

    data: any;
    finalHPToken: any;
    setConfig() {
        this.config = this._appConfigService.getConfig("api");
        // api = this.config;
        this.endpointMap =
          Object
            .keys(this.config?.endpoints)
            .reduce((map, endpoint, i) => {
              map[i] = [endpoint, this.config?.endpoints[endpoint]];
              return map;
            }, []);
        this.channel = this.config?.channel;
        this.endpoints = new Map(this.endpointMap);
      }
       
generatehoneyPotToken() {
    if(isPlatformBrowser(this.platformId)) {
        let headerData = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        return this._http.post(this.endpoints.get('honeyPotTokenURL'), { headers: headerData })
        .pipe(
            map((res: any) => {
                let hpData = res;
                if(hpData.HPToken !== null && hpData.HPToken !== "" && hpData.HPToken !== "null"){
                    let hpTokenLen = hpData.Length;
                    let hpToken = hpData.HPToken;
                    this.finalHPToken = hpToken.substring(hpToken.length - hpTokenLen);
                }
                return this.finalHPToken;
           })
        ).pipe(
                catchError((error) => this.handleError(error))
            )
    }else{
        return of(true);
    }
}

handleError(error: any) {
    return throwError(error)
  }

}